import dayjs from 'dayjs'

export const isRunningToday = (p: any) => {
  const start = p?.startDate
  const end = p?.endDate
  if (!start || !end) return false
  const s = dayjs(start)
  const e = dayjs(end)
  if (!s.isValid() || !e.isValid()) return false

  const today = dayjs()
  // inclusive range
  return (today.isAfter(s, 'day') || today.isSame(s, 'day')) && (today.isBefore(e, 'day') || today.isSame(e, 'day'))
}
